import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getModels } from '../services/api';

interface Model {
  id: number;
  name: string;
  thumbnail: string;
  locked: boolean;
  package_url: string;
}

const Gallery: React.FC = () => {
  const [models, setModels] = useState<Model[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        setLoading(true);
        const response = await getModels();
        setModels(response);
        setError(null);
      } catch (err) {
        setError('Failed to fetch models. Is the backend server running?');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchModels();
  }, []);

  return (
    <div className="page-container">
      <h2>2D Model Gallery</h2>
      {loading && <p>Loading models...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <div className="gallery-container">
        {models.map((model) => (
          <div key={model.id} className="model-card">
            <img src={model.thumbnail} alt={model.name} />
            <h3>{model.name}</h3>
            <p>{model.locked ? '🔒 Locked' : '✅ Unlocked'}</p>
            {!model.locked && (
              <Link to={`/vr?modelUrl=${encodeURIComponent(model.package_url)}`} 
                    style={{ 
                      display: 'inline-block', 
                      marginTop: '10px', 
                      padding: '8px 16px', 
                      backgroundColor: '#00e6ff', 
                      color: '#000', 
                      textDecoration: 'none', 
                      borderRadius: '4px',
                      fontWeight: 'bold'
                    }}>
                View in VR
              </Link>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
